export default {
  'Download Mobile App': 'App herunterladen',
  'Buy Now': 'Jetzt kaufen',
  'Contact Us': 'Kontakt',
  'Copyright @ 2020, Famikit.com. All rights reserved.': 'Copyright @ 2020, Famikit.com. Alle Rechte vorbehalten.',
  'Welcome to FamiKit': 'Willkommen bei FamiKit',
  'Sign in': 'Anmelden',
  'Home': 'Startseite',
  'Sreen Time': 'Bildschirmzeit',
  'Apps Time': 'App-Nutzung',
  'Website Filter': 'Website-Filter',
  'Geofences': 'Geofencing',
  'Notifications': 'Benachrichtigungen',
  'My': 'Account',
  'Screen time': 'Bildschirmzeit',
  'Most apps used': 'Meist verwendete Apps',
  'No data display': 'Keine Daten gefunden',
  "You have not installed Famikit on your child's phone. After installation, you can reopen Famikit on this device to see the statistics of children's mobile phones.": "Sie haben FamiKit nicht auf dem Telefon des Kindes installiert. Nach der Installation können Sie FamiKit auf diesem Gerät erneut öffnen, um die Handy-Statistiken Ihres Kindes anzuzeigen.",
  'What should I do ?': 'Was soll ich machen ?',
  "1. Get the child's cell phone": "1. Holen Sie sich das Handy Ihres Kindes",
  '2. Open Google play, search and install famikit': '2. Öffnen Sie Google Play, suchen und installieren Sie FamiKit',
  '3. Clock in famikit and log in（ {email} ）, select role child': '3. Starten Sie FamiKit und melden Sie sich an ({email}). Wählen Sie die untergeordnete Rolle aus',
  '4. Follow the instructions in famikit to set permissions': "4. Befolgen Sie die Anweisungen von FamiKit, um Berechtigungen festzulegen",
  'Name': 'Name',
  'Used time': 'Nutzungszeit',
  'Limit duration': 'Zeitlimit',
  'Restricted period': 'Sperrfrist',
  'Limit set': 'Limit setzen',
  'Set App usage time': 'die App-Nutzungszeit einstellen',
  'Limit wechat usage time': 'Limit WeChat usage time',
  'Note: set the maximum time that the app can be used': 'Hinweis: Legen Sie hier die maximale Nutzungsdauer der App fest',
  'Repeat': 'Wiederholen',
  'Save': 'Speichern',
  'Cancel': 'Abbrechen',
  'hour': 'Std.',
  'min': 'Min.',
  'Set app usage period': 'die Nutzungsdauer der App einstellen',
  'Start': 'Anfang',
  'End': 'Ende',
  'Limit Screen usage time': 'die Nutzungsdauer des Bildschirms festlegen',
  'Limited to {time} hours per day': 'Begrenzt auf {time} Stunden pro Tag',
  'Set screen usage time': 'die Bildschirmnutzungszeit einstellen',
  'Set exception app': 'Ausnahme-App einstellen',
  'Limit screenusage time': 'die Bildschirmnutzungszeit limitieren',
  'Exception app can be used without time limit': 'Die Ausnahme-App kann während des Zeitlimits genutzt werden',
  'Email cannot be blank.': 'E-Mail darf nicht leer sein.',
  'Please enter a valid email address': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  "Password": "Passwort",
  "Repeat Password": "Passwort bestätigen",
  'I agree': 'Zustimmen',
  'User agreement': 'Nutzungsbedingungen',
  'and': 'und',
  'Privacy policy': 'Datenschutzerklärung',
  'Register': 'Registrieren',
  'Existing account?': 'Bereits ein Konto?',
  'Password cannot be blank.': 'Das Passwort darf nicht leer sein.',
  'Repeat Password cannot be blank.': 'Das Bestätigungspasswort darf nicht leer sein.',
  'The two passwords you entered do not match.': 'Die beiden eingegebenen Passwörter stimmen nicht überein.',
  'Please read and agree to the terms of service first.': 'Bitte lesen Sie zuerst die Nutzungsbedingungen und stimmen Sie diesen zu.',
  'Username already exists.': 'Benutzername existiert bereits.',
  'unexpected error.': 'Unerwarteter Fehler.',
  'Email': 'E-Mail',
  'Network delay, please try again.': 'Netzwerkverzögerung, bitte versuchen Sie es erneut.',
  'Incomplete parameters.': 'Der Parameter ist unvollständig.',
  'Username does not exist.': 'Der Benutzername existiert nicht.',
  'Incorrect username or password.': 'Falscher Benutzername oder falsches Passwort.',
  'Return': 'Zurück',
  'Choose your subscription plan and get started': 'Wählen Sie Ihr Abonnement und legen Sie los',
  "Note: the number of devices refers to the number of children's devices that can be bound. Binding is to access your child's device and install it from Google play.": "Hinweis: Die Anzahl der Geräte bezieht sich auf die Anzahl der Kindergeräte, die gebunden werden können. Sie müssen Zugriff auf das Gerät Ihres Kindes haben und FamiKit über Google Play installieren.",
  'Register now': 'Jetzt registrieren',
  'No account?': 'Noch kein Konto?',
  'Add to Cart': 'In den Warenkorb legen',
  'Store': 'Shop',
  'MONTHLY': 'MONATLICH',
  '$ 7.99 / Month': '$ 7.99 / Monat',
  'Can be bound to': 'Kann gebunden werden an',
  'devices': 'Geräte',
  '$ 5.99 / Month': '$ 5.99 / Monat',
  '$ 4.99 / Month': '$ 4.99 / Monat',
  'Subscribe': 'Abonnieren',
  'QUARTERLY': 'VIERTELJÄHRLICH',
  'ANNUAL': 'JÄHRLICH',
  'Note': 'Anmerkung',
  'download New Version Note!': 'Neue Version verfügbar!',
  'No': 'Nein',
  'Yes': 'Ja',
  'Account expired': 'Konto abgelaufen',
  'Account expired Please renew!': 'Ihr Konto ist abgelaufen, bitte verlängern!',
  'New data is uploading, it may take a while.': 'Das Hochladen neuer Daten kann eine Weile dauern.',
  "1. Get your kid's cell phone.": "1. Holen Sie sich das Handy Ihres Kindes.",
  "2. Visit famikit.com in browser, download and install FamiKit App.": "2. Besuchen Sie famikit.com im Browser, laden Sie die FamiKit App herunter und installieren Sie sie.",
  "3. Open FamiKit app, sign in（ {email} ）and select kid's role.": "3. Öffnen Sie die FamiKit-App, melden Sie sich an ({email}) und wählen Sie die Kinderrolle aus.",
  '4. Follow the instructions in FamiKit to set permissions.': '4. Befolgen Sie die Anweisungen in FamiKit, um Berechtigungen festzulegen.',
  '5. Refresh this page.': '5. Aktualisieren Sie diese Seite.',
  'Refresh Now.': 'Jetzt aktualisieren.',
  'Limited to {time} per day': 'Begrenzt auf {time} pro Tag',
  'Current account is not activated.': 'Das aktuelle Konto ist nicht aktiviert.',
  'About': 'Über',
  'User privacy agreement': 'Datenschutzvereinbarung',
  'No data found': 'Keine Daten gefunden',
  'Updated {times} ago': 'Vor {times} aktualisiert',
  'No location information': 'Keine Standortinformationen',
  'please wait...': 'Warten Sie mal...',
  'Used for': 'Benutzt',
  'Today': 'Heute',
  'Yesterday': 'Gestern',
  'Last 3 Days': 'Letzte 3 Tage',
  'Last 7 Days': 'Letzte 7 Tage',
  'Social contact': 'Soziale Apps',
  'Other': 'Andere',
  'Game': 'Spiel',
  'Please confirm': 'Bitte bestätigen',
  '1. The childs mobile phone is connected to the Internet and the position switch is turned on.': "1. Das Handy des Kindes ist mit dem Internet verbunden und der Standortschalter ist eingeschaltet.",
  '2. Whether the famikit in the childs mobile phone is turned on.': "2. Ob FamiKit im Handy Ihres Kindes aktiviert ist.",
  'OK': 'OK',
  'Valid until': 'Gültig bis',
  'Update subscription': 'Abonnement aktualisieren',
  'kids equipment': "Kindergerät",
  'Disconnect': 'Trennen',
  'My Account': 'Mein Konto',
  'Sign out': 'Abmelden',
  'Cancel account': 'Account löschen',
  'You will not be able to receive device status after disconnection. Are you sure you want to disconnect ?': 'Nach dem Trennen der Verbindung können Sie den Gerätestatus nicht mehr empfangen. Sind Sie sicher, dass Sie die Verbindung trennen möchten?',
  'Are you sure you want to exit ?': 'Sind Sie sicher, dass Sie beenden möchten',
  'Warning: after the account is cancelled, your data will be cleared and cannot be retrieved. Are you sure you want to delete the account ?': 'Warnung: Sobald das Konto aufgelöst wurde, werden Ihre Daten gelöscht und können nicht mehr abgerufen werden. Möchten Sie das Konto wirklich löschen?',
  'Delete all': 'Alles löschen',
  'Mark all as read': 'Alle als gelesen markiert',
  'Limit time interval': 'Zeitintervall limitieren',
  'Set Time Limits': 'Zeitlimits festlegen',
  'Set screen usage period': 'die Nutzungsdauer des Bildschirms einstellen',
  'Set app time limit': 'App-Zeitlimit festlegen',
  'Limit usage period': 'Nutzungsdauer beschränken',
  'Monday': 'Montag',
  'Tuesday': 'Dienstag',
  'Wednesday': 'Mittwoch',
  'Thursday': 'Donnerstag',
  'Friday': 'Freitag',
  'Saturday': 'Samstag',
  'Sunday': 'Sonntag',
  'Add exception': 'Ausnahme hinzufügen',
  'Search locations': 'Standorte suchen',
  'Rule': 'Regel',
  'Prevent': 'Verhindern',
  'Allow': 'Zulassen',
  'Website filtering': 'Website-Filter',
  'Customize site access, block or allow': 'Passen Sie den Site-Zugriff an, blockieren oder zulassen',
  'Are you sure you want to delete the filter settings ?': 'Möchten Sie die Filtereinstellungen wirklich löschen?',
  'Filtering web browser access by category and URL': 'den Webbrowser-Zugriff nach Kategorie und URL filtern',
  '（Only Chrome browser is supported）': '(Nur der Chrome-Browser wird unterstützt.)',
  '$ {Month} / Month': '$ {Month} / Monat',
  'Radius of the geofence in meters ({0}) m max.': 'Radius des Geofence, das Maximum ist ({0}) m.',
  'Out': 'Aus',
  'In': 'In',
  'search': 'Suchen',
  'Name the Geofence': 'Geofence nennen',
  'NameBeBlank': 'Der Name darf nicht leer sein',
  'Radius of the geofence in meters （1000m max.）': 'Radius des Geofence in Metern (max. 1000 m)',
  'Are you sure you want to select the deleted geofence': 'Möchten Sie den ausgewählten Geofence wirklich löschen?',
  'Most Used': 'Am Meisten verwendet',
  'Set Limits': 'Grenzen setzen',
  'Limit Screen Time': 'Bildschirmzeit begrenzen',
  'Allow: {time} ': 'Verfügbar: {time} ',
  'Downtime': 'Auszeit',
  'Note: This is the maximum time that kid’s phone can be used.': 'Hinweis: Dies ist die maximale Zeit, die ein Kind das Telefon benutzen kann.',
  'Always Allowed': 'Immer erlaubt',
  'Choose apps that your kids can use all the time.': 'Wählen Sie Apps, die Ihre Kinder jederzeit nutzen können.',
  'Duration Limit': 'Limit für Dauer',
  'Customize site access: Prevent or Allow.': 'Site-Zugriffs einstellen: Verhindern oder Zulassen.',
  'Enter URL': 'URL eingeben',
  'Restriction': 'Beschränkung',
  'Exception': 'Ausnahme',
  'Adult': 'Inhalt für Erwachsene',
  'Alcohol': 'Alkohol & Tabak',
  'Anonymizers': 'Anonymisierer',
  'Gambling': 'Glücksspiel',
  'Games': 'Spiele',
  'Job': 'Job',
  'Music': 'Musik & Video',
  'News': 'Neue Medien',
  'Profanity': 'Profanität',
  'Religions': 'Religionen',
  'Search': 'Suchen',
  'Shopping': 'Einkaufen',
  'Social': 'Soziale Apps',
  'Unknown': 'Unbekannt',
  'Violence': 'Gewalt',
  'Weapons': 'Waffen',
  'Try it now': 'Versuch mal jetzt',
  'Your kid cannot use the device during the time limit.': 'Ihr Kind kann das Gerät während des Zeitlimits nicht benutzen.',
  'famiKit（ {ver} ）is now available for your kid. Please go toGoogle Play Store and install the latest version of Famikit on yourkid’s device': "FamiKit ({ver}) ist jetzt für Ihr Kind verfügbar. Bitte gehen Sie zum Google Play Store und installieren Sie die neueste Version von FamiKit auf dem Gerät Ihres Kindes.",
  'famikit（ {ver} ）is now available for your kid. Please go to': 'FamiKit ({ver}) ist jetzt für Ihr Kind verfügbar. Bitte gehen Sie zu',
  'famikit.com': 'famikit.com',
  'and install the latest version of Famikit for PC on yours device': 'und installieren Sie die neueste Version von FamiKit für PC auf Ihrem Gerät.',
  '3. Open FamiKit app, sign in（ {email} ）': '3. Öffnen Sie die FamiKit-App, melden Sie sich an ({email})',
  'Kid device is Android': 'Das Gerät des Kindes ist Android',
  'Kid device is Windows': 'Das Gerät des Kindes ist Windows',
  '2. Visit famikit.com in browser, download and install Famikit App.': '2. Öffnen Sie famikit.com im Browser, laden Sie die FamiKit-App herunter und installieren Sie sie.',
  "1. Get your kid's PC": "1. Gehen Sie zum PC Ihres Kindes",
  '2. Download FamiKit android app from Google Play': '2. Laden Sie die FamiKit-Android-App aus dem Google Play Store herunter',
  'Browser Histroy': 'Browserverlauf',
  'Enable Brower History': 'Browserverlauf aktivieren',
  'After opening, it will record the browsing records of chrome, Firefox, edge and other browsers.': 'Nach dem Aktivieren der Option wird der Browserverlauf von Chrome, Firefox, Edge und anderen Browsern aufgezeichnet.'
}




// WEBPACK FOOTER //
// ./src/language/de.js